import { createContext, useContext } from "react";

export type ThemeContextType = {
  displayName: string;
  logo: string;
  customLoaderImage: string;
  setTheme: (config: Partial<ThemeContextType>) => void;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined
);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
